import { useEffect } from 'react';
import installSelectSheetRuntime, {
  SelectSheetOptions,
} from './selectSheetRuntime';
import './selectSheetSearch.less';

/**
 * Phones: searchable selects get a search bar at the top of their bottom
 * sheet (by default a tap opens the sheet without raising the keyboard;
 * `typeOnOpen` raises it straight away), multiple selects optionally a strip
 * of their picked values — see selectSheetRuntime.ts.
 * Mount once per app; `noSheetClass` marks dropdowns that are not sheets.
 */
const useSelectSheetRuntime = (
  enabled: boolean,
  noSheetClass: string,
  options: Omit<SelectSheetOptions, 'noSheetClass'> = {}
) => {
  const { typeOnOpen, selectedChips, searchLabel, removeLabel } = options;
  useEffect(() => {
    if (!enabled) return undefined;
    return installSelectSheetRuntime({
      noSheetClass,
      typeOnOpen,
      selectedChips,
      searchLabel,
      removeLabel,
    });
  }, [enabled, noSheetClass, typeOnOpen, selectedChips, searchLabel, removeLabel]);
};

export default useSelectSheetRuntime;
